<template>
    <div class="commission-setting">
      <div class="header">
        <h2>返佣设置</h2>
        <el-button type="primary" @click="saveSettings">保存设置</el-button>
      </div>
  
      <div class="setting-container">
        <!-- 政商企让利设置 -->
        <div class="setting-card">
  <div class="setting-title">
    <h3>政商企让利设置</h3>
    <el-tag type="info">政商企让出固定金额用于返佣</el-tag>
  </div>
  <div class="setting-content">
    <el-form label-width="180px">
              <el-form-item label="政商企让利类型">
                <el-radio-group v-model="settings.merchant_discount.type">
                  <el-radio :label="'fixed'">固定金额</el-radio>
                  <el-radio :label="'percent'">百分比</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="返佣值">
                <el-input-number 
                  v-model="settings.merchant_discount.value" 
                  :min="0" 
                  :step="settings.merchant_discount.type === 'fixed' ? 0.1 : 0.1"
                  :precision="2"
                ></el-input-number>
                <span class="unit">{{ settings.merchant_discount.type === 'fixed' ? '元' : '%' }}</span>
              </el-form-item>
            </el-form>
  </div>

</div>

  
        <!-- 消费者返佣设置 -->
        <div class="setting-card">
          <div class="setting-title">
            <h3>消费者返佣设置</h3>
            <el-tag type="info">直接返利给消费者的金额</el-tag>
          </div>
          <div class="setting-content">
            <el-form label-width="180px">
              <el-form-item label="返佣类型">
                <el-radio-group v-model="settings.consumer_rebate.type">
                  <el-radio :label="'fixed'">固定金额</el-radio>
                  <el-radio :label="'percent'">百分比</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="返佣值">
                <el-input-number 
                  v-model="settings.consumer_rebate.value" 
                  :min="0" 
                  :step="settings.consumer_rebate.type === 'fixed' ? 0.1 : 0.1"
                  :precision="2"
                ></el-input-number>
                <span class="unit">{{ settings.consumer_rebate.type === 'fixed' ? '元' : '%' }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
  
        <!-- 平台返佣设置 -->
        <div class="setting-card">
          <div class="setting-title">
            <h3>平台返佣设置</h3>
            <el-tag type="info">平台收取的佣金比例</el-tag>
          </div>
          <div class="setting-content">
            <el-form label-width="180px">
              <el-form-item label="返佣类型">
                <el-radio-group v-model="settings.platform_rebate.type">
                  <el-radio :label="'fixed'">固定金额</el-radio>
                  <el-radio :label="'percent'">百分比</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="返佣值">
                <el-input-number 
                  v-model="settings.platform_rebate.value" 
                  :min="0" 
                  :step="settings.platform_rebate.type === 'fixed' ? 0.1 : 0.1"
                  :precision="2"
                ></el-input-number>
                <span class="unit">{{ settings.platform_rebate.type === 'fixed' ? '元' : '%' }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
  
        <!-- 消费者上级返佣设置 -->
        <div class="setting-card">
          <div class="setting-title">
            <h3>消费者上级返佣设置</h3>
            <el-tag type="info">返利给消费者的上级</el-tag>
          </div>
          <div class="setting-content">
            <el-form label-width="180px">
              <el-form-item label="返佣类型">
                <el-radio-group v-model="settings.consumer_superior_rebate.type">
                  <el-radio :label="'fixed'">固定金额</el-radio>
                  <el-radio :label="'percent'">百分比</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="返佣值">
                <el-input-number 
                  v-model="settings.consumer_superior_rebate.value" 
                  :min="0" 
                  :step="settings.consumer_superior_rebate.type === 'fixed' ? 0.1 : 0.1"
                  :precision="2"
                ></el-input-number>
                <span class="unit">{{ settings.consumer_superior_rebate.type === 'fixed' ? '元' : '%' }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
  
        <!-- 政商企上级返佣设置 -->
        <div class="setting-card">
          <div class="setting-title">
            <h3>政商企上级返佣设置</h3>
            <el-tag type="info">返利给政商企的上级</el-tag>
          </div>
          <div class="setting-content">
            <el-form label-width="180px">
              <el-form-item label="返佣类型">
                <el-radio-group v-model="settings.merchant_superior_rebate.type">
                  <el-radio :label="'fixed'">固定金额</el-radio>
                  <el-radio :label="'percent'">百分比</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="返佣值">
                <el-input-number 
                  v-model="settings.merchant_superior_rebate.value" 
                  :min="0" 
                  :step="settings.merchant_superior_rebate.type === 'fixed' ? 0.1 : 0.1"
                  :precision="2"
                ></el-input-number>
                <span class="unit">{{ settings.merchant_superior_rebate.type === 'fixed' ? '元' : '%' }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
  
        <!-- 比例总和显示 -->
        <!-- <div class="setting-card total-card">
          <div class="setting-title">
            <h3>比例分配总和</h3>
            <el-tag :type="totalValid ? 'success' : 'danger'">
              {{ totalPercent }}% / {{ settings.merchant_discount.rate }}%
            </el-tag>
          </div>
          <div class="setting-content">
            <el-progress 
              :percentage="totalPercent" 
              :status="totalValid ? 'success' : 'exception'"
              :format="formatProgress"
            ></el-progress>
            <div class="total-tip" :class="{ error: !totalValid }">
              {{ totalValid ? '比例分配正确' : '比例分配不正确，请调整' }}
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </template>
  
  <script>
  import SettingApi from '@/api/setting.js';
  export default {
    data() {
      return {
        settings: {
          merchant_discount: {
            type: 'percent',
            amount:0,
            rate: 100
          },
          consumer_rebate: {
            type: 'percent', // fixed 或 percent
            value: 4 // 返佣值
          },
          platform_rebate: {
            type: 'percent',
            value: 2
          },
          consumer_superior_rebate: {
            type: 'percent',
            value: 2
          },
          merchant_superior_rebate: {
            type: 'percent',
            value: 2
          }
        }
      }
    },
    computed: {
      // 计算百分比总和

      totalRebate() {
    let total = 0;
    const merchantAmount = this.settings.merchant_discount.amount || 0;

    // 消费者返佣
    if (this.settings.consumer_rebate.type === 'percent') {
      total += merchantAmount * this.settings.consumer_rebate.value / 100;
    } else {
      total += Number(this.settings.consumer_rebate.value);
    }

    // 平台返佣
    if (this.settings.platform_rebate.type === 'percent') {
      total += merchantAmount * this.settings.platform_rebate.value / 100;
    } else {
      total += Number(this.settings.platform_rebate.value);
    }

    // 消费者上级返佣
    if (this.settings.consumer_superior_rebate.type === 'percent') {
      total += merchantAmount * this.settings.consumer_superior_rebate.value / 100;
    } else {
      total += Number(this.settings.consumer_superior_rebate.value);
    }

    // 政商企上级返佣
    if (this.settings.merchant_superior_rebate.type === 'percent') {
      total += merchantAmount * this.settings.merchant_superior_rebate.value / 100;
    } else {
      total += Number(this.settings.merchant_superior_rebate.value);
    }

    return parseFloat(total.toFixed(2));
  },
  // 验证总和是否等于政商企让利金额
  totalValid() {
    const merchantAmount = this.settings.merchant_discount.amount || 0;
    return Math.abs(this.totalRebate - merchantAmount) < 0.01;
  },
  merchantBase() {
    const md = this.settings.merchant_discount;
    return md.type === 'fixed' ? md.amount : (订单总金额 * md.rate / 100);
  },
  
  // 返佣总额计算（示例：消费者返佣）
  consumerRebateAmount() {
    const cr = this.settings.consumer_rebate;
    return cr.type === 'percent' 
      ? this.merchantBase * cr.value / 100 
      : cr.value;
  }

    },
    created() {
      this.loadSettings();
    },
    methods: {
      // 进度条格式化
      formatProgress() {
        return `${this.totalPercent}% / ${this.settings.merchant_discount.rate}%`;
      },
      // 加载设置
      loadSettings() {
        var self = this;
        SettingApi.getCommissionSettings(true).then(res => {
          console.log(res);
          self.settings = res.data || self.settings;
        }).catch(err => {
          this.$message.error('加载设置失败');
        });
      },
      
      // 保存设置
      saveSettings() {
        // 验证数据
        if (!this.validateSettings()) {
          return;
        }
        SettingApi.saveCommissionSettings(this.settings, true).then(res => {
          this.$message.success('保存成功');
        }).catch(err => {
          this.$message.error('保存失败');
        });
      },
      
      // 验证设置
        validateSettings() {
    // 验证政商企让利金额
    if (this.settings.merchant_discount.amount <= 0) {
      this.$message.error('政商企让利金额必须大于0');
      return false;
    }

    // 验证各返佣项的值是否合法
    const validateRebate = (rebate, name) => {
      if (rebate.type === 'percent') {
        if (rebate.value < 0 || rebate.value > 100) {
          this.$message.error(`${name}百分比必须在0-100之间`);
          return false;
        }
      } else {
        if (rebate.value <= 0) {
          this.$message.error(`${name}金额必须大于0`);
          return false;
        }
      }
      return true;
    };

    if (!validateRebate(this.settings.consumer_rebate, '消费者返佣')) return false;
    if (!validateRebate(this.settings.platform_rebate, '平台返佣')) return false;
    if (!validateRebate(this.settings.consumer_superior_rebate, '消费者上级返佣')) return false;
    if (!validateRebate(this.settings.merchant_superior_rebate, '政商企上级返佣')) return false;

    // 验证总和是否等于政商企让利金额
    if (!this.totalValid) {
      this.$message.error(`返佣金额总和(${this.totalRebate}元)必须等于政商企让利金额(${this.settings.merchant_discount.amount}元)`);
      return false;
    }

    return true;
  }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .commission-setting {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100%;
    
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      
      h2 {
        margin: 0;
        color: #303133;
      }
    }
    
    .setting-container {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
      gap: 20px;
      
      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    }
    
    .setting-card {
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 20px;
      
      &.total-card {
        grid-column: 1 / -1;
      }
      
      .setting-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #ebeef5;
        
        h3 {
          margin: 0;
          font-size: 16px;
          color: #303133;
        }
      }
      
      .setting-content {
        .unit {
          margin-left: 10px;
          color: #909399;
        }
        
        /deep/ .el-input-number {
          width: 200px;
        }
        
        .total-tip {
          margin-top: 10px;
          text-align: center;
          color: #67C23A;
          
          &.error {
            color: #F56C6C;
          }
        }
      }
    }
  }
  </style>


// WEBPACK FOOTER //
// src/views/setting/commission/index.vue